import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import {CompanyProps} from 'modules/companies/types';
import useCityBillingRecorency from 'modules/cities/hooks/use-city-billing-recorency';
import {BillingRecorencyEnum} from 'modules/cities/types';

const BillingRecorency: React.FC = () => {
  const {id} = useParams();
  const {data = [], isLoading} = useCityBillingRecorency(id!);
  const navigate = useNavigate();

  return (
    <Table<CompanyProps>
      loading={isLoading}
      {...{data}}
      options={[
        'name',
        {
          value: 'billingRecorency',
          column: (row) =>
            row.billingRecorency === BillingRecorencyEnum.FORTNIGHTLY
              ? 'Quinzenal'
              : row.billingRecorency === BillingRecorencyEnum.WEEKLY
              ? 'Semanal'
              : 'Mensal',
        },
      ]}
      translatedPropsKey="CompanyProps"
      onRowClick={(row) =>
        navigate('create', {
          state: {billingRecorency: row.billingRecorency, companyId: row.id},
        })
      }
    />
  );
};

export default BillingRecorency;
